/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded Folder with colour.
 */
export const CUSTOM_ICON_FOLDER_COLOUR = (
  <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <mask height="24" id="mask0_108_3386" maskUnits="userSpaceOnUse" width="24" x="0" y="0">
      <path d="M24 0H0V24H24V0Z" fill="white" />
    </mask>
    <g mask="url(#mask0_108_3386)">
      <path d="M24 0H0V24H24V0Z" fill="transparent" />
      <path
        d="M0 4.5C0 2.84315 1.34315 1.5 3 1.5H10.3944C11.3975 1.5 12.3342 2.0013 12.8906 2.8359L15 6L0 20.4V4.5Z"
        fill="#EFB324"
      />
      <path
        d="M23.25 19.5V7.5C23.25 6.25735 22.2426 5.25 21 5.25H13.5H10.5H2.98506C1.75121 5.25 0.747517 6.24371 0.735179 7.4775L0.607621 20.235C0.599279 21.0693 1.27326 21.75 2.10755 21.75H21C22.2426 21.75 23.25 20.7426 23.25 19.5Z"
        fill="#FBEFD2"
        stroke="#F5D584"
      />
    </g>
  </svg>
);
